import ValueTracker from "../prop-trackers/value-tracker.js";
import DictTrackerObjGen from "../prop-tracker-utils/dict-tracker-obj-gen.js";
import ValueTrackerObjGen from "../prop-tracker-utils/value-tracker-obj-gen.js";

class DictTrackerObjPtrGen {
    constructor(wrapCtx, evtCtx, dictTracker) {
        this._dictPtrTracker = new ValueTracker();
        this._dictPtrGen = new ValueTrackerObjGen(wrapCtx, evtCtx, this._dictPtrTracker);

        this._dictGen = new DictTrackerObjGen(wrapCtx, evtCtx, dictTracker);
    }

    get pointer() { return this._dictPtrGen; }

    start() {
        this._dictPtrTracker.setValue(this._dictGen.data);
    }

    stop() {
        this._dictPtrTracker.deleteValue();
    }

    update() {
        this._dictGen.update();
        this._dictPtrGen.update();
    }
}

export default DictTrackerObjPtrGen;
